module.exports = __webpack_public_path__ + "img/rtb_silo_6.028c5fd0.png";